import { MAX_MODULE_DURATION_SECONDS } from '../consts';
import dateToEpochSeconds from './dateToEpochSeconds';
export default function calculateCappedModuleDuration(timeStarted, timeFinished) {
    //It is possible for a student to change their time zone and have a study time difference
    //Here we take the absolute time difference to ensure it is always positive https://github.com/SenecaLabs/senecaWeb/pull/16969#issuecomment-2074934411
    const moduleStudyTime = Math.abs(dateToEpochSeconds(timeFinished) - dateToEpochSeconds(timeStarted));
    return Math.min(moduleStudyTime, MAX_MODULE_DURATION_SECONDS);
}
